import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { settingsViewInit } from '../settingsViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof settingsViewInit>;
type OUT = ReturnType<typeof settingsViewInit>;

export const SettingsViewInitEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(settingsViewInit.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [];
    }),
  );
